<template>
    <div>
        <div class="d-flex align-items-center">
            <label class="switch mb-0">
                <input :id="id" v-model="valModel" :disabled="disabled" type="checkbox">
                <span
                    class="slider"
                    :class="{
                        round: rounded,
                        [offSliderClass]: !valModel && offSliderClass,
                        [onSliderClass]: valModel && onSliderClass
                    }"></span>
            </label>
            <span
                v-if="label"
                class="text-break ml-2"
                :class="[{'d-none d-xl-inline-flex': hideText}, textClass]">
                {{ label }}
            </span>
        </div>
        <div v-if="showIndicator" class="indicator-label">
            <span
                class="badge text-uppercase rounded-pill px-2 py-1 mt-1"
                :class="valModel ? 'indicator-on' : 'indicator-off'">
                {{ indicatorText }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EToggle',
    props: {
        value: [Object, Boolean, Array, Number, String],
        id: {
            type: String,
            required: true
        },
        label: String,
        showIndicator: {
            type: Boolean,
            default: false
        },
        disabled: Boolean,
        rounded: {
            type: Boolean,
            default: true
        },
        hideText: {
            type: Boolean,
            default: false
        },
        textClass: String,
        offSliderClass: String,
        onSliderClass: String
    },
    computed: {
        indicatorText() {
            return this.valModel ? this.$t('Toggle on') : this.$t('Toggle off');
        },
        valModel: {
            get() {
                return !!+this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@common/styles/variables/_variables.scss";

/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 44px;
    min-width: 44px;
    height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    opacity: 0;
    cursor: pointer;
}

.switch input:disabled {
    cursor: not-allowed;
}

/* The slider */
.slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    background-color: $gray-400;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 19px;
    width: 19px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: $success;
}

input:focus + .slider {
    box-shadow: 0 0 1px $success;
}

input:focus-visible + .slider {
    box-shadow: 0 0 0 2px $text-black;
}

input:checked + .slider:before {
    -webkit-transform: translateX(18px);
    -ms-transform: translateX(18px);
    transform: translateX(18px);
}

input:disabled + .slider {
    opacity: 0.4;
    cursor: not-allowed;
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.indicator-label {
    line-height: 1;
}

.indicator-label .badge {
    font-weight: 600;
}

.indicator-on {
    background-color: $light-green;
    color: $dark-green;
}

.indicator-off {
    background-color: $gray-200;
}
</style>
